import React from 'react'
import "../App.css"

import { createUseStyles } from "react-jss";


export default function MzText({value , className, style}) {
    const st =styles();
  return (
    <div className={ st.text_container+" "+className} style={style}>{value}</div>
  )
}


const styles = createUseStyles({
    text_container: {
        width: "fit-content"
    },
   
  
  });